import {Flex, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC, PropsWithChildren} from 'react';

interface IProps {}

export const CloseProviderBanner: FC<PropsWithChildren<IProps>> = ({children}) => {
  if (!children) return null;

  return (
    <Flex justifyContent="center" alignItems="center" w="100%" h="100%" position="absolute" zIndex={9}>
      <Text as="span" position="absolute" w="100%" h="100%" bg="black" opacity={0.4} borderRadius="16px" />
      <Text as="span" fontWeight="bold" fontSize="18px" color={colors.white} zIndex={9} textAlign="center">
        {children}
      </Text>
    </Flex>
  );
};
